
export const UUID_SIZE: number = 16;

export const WEAKMAP_PREFIX: string = "@@WeakMap@@";



/** WEBPACK FOOTER **
 ** ./src/helper/helper-constants.ts
 **/